/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {Field} from 'formik'

import InputAdornment from '@mui/material/InputAdornment'
import FormControl from '@mui/material/FormControl'

import {FormikTextField, MoneyField} from '../../generics'


const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 24px;
  `
}



const EventFormTickets = ({values, setFieldValue}) => {
  return (
    <div css={styles.container}>
      <FormControl fullWidth>
        <Field
          name='tickets'
          label='Link'
          component={FormikTextField}
          onBlur={e => setFieldValue('tickets', e.target.value.trim())}
        />
      </FormControl>

      <FormControl>
        <Field
          name='price'
          label='Price'
          component={MoneyField}
          InputProps={{ startAdornment: <InputAdornment position='start'>$</InputAdornment> }}
        />
      </FormControl>
    </div>
  )
}


export default EventFormTickets
